import React, { useEffect, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';
import { setUserData } from '../../Redux/ActionCreater';
import axios from 'axios';
import { BASE_IMAGE_URL, BASE_URL } from '../../config';
import { toast } from 'react-toastify';
import { FaCamera } from "react-icons/fa";
import logo from "../../Assets/images/bwu-logo.webp";
function DashboardHeader() {
    return (
        <footer className="footer">
            <div className="">
                <div className="">
                    <div className="d-sm-flex justify-content-center justify-content-sm-between">
                        <span className="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2024 <a href="https://www.brainwareuniversity.ac.in/" className="text-muted" target="_blank">Brainware
                            University</a>.
                            All
                            rights reserved.</span>
                    </div>
                </div>
            </div>
        </footer>


    )
}

export default DashboardHeader